/** Patient aligner testimonial (4:5, ~19 s, speech then an intentionally silent final clip). */
export const alignerReviewVideo = {
  src: 'https://cdn.magicpatterns.com/uploads/vDE9Tkj1fGj9bTLpg6TEki/dentico_patient_experience_aligner_review_4x5.mp4',
  /** Second of the video shown as the still cover before playback. Adjust to a smiling frame. */
  posterTimeSeconds: 1.5,
}
